import './App.css';
import React, { lazy, Suspense, useMemo } from "react";
import { Box } from '@mui/material';

import { useGlobalState } from 'context/GlobalStateContext';
import { Fallback } from 'components/FallbackLoading';

const Template1     = lazy(() => import("template/template1/layout/index"));
const PulseTemplate = lazy(() => import("template/pulse_template/layout/index"));
const ShopyTemplate = lazy(() => import("template/shopy_template/layout/index"));

const TEMPLATE_MAP = {
  HORIZON: Template1,
  PULSE:   PulseTemplate,
  SHOPY:   ShopyTemplate,
};

const suspenseFallback = (
  <Box sx={{ height: '100vh' }}>
    <Fallback />
  </Box>
);

function App() {
  const { templateData: { templateCode } = {} } = useGlobalState() || {};

  const SelectedTemplate = useMemo(
    () => TEMPLATE_MAP[templateCode] ?? Template1,
    [templateCode]
  );

  return (
    <div className={`App-${templateCode}`} id="App" data-testid="App">
      <Suspense fallback={suspenseFallback}>
        <SelectedTemplate />
      </Suspense>
    </div>
  );
}

export default App;
